import { useMemo } from 'react';

import { createAvaAIClientToolRouter, type AvaAIClientToolRegistry } from './clientToolHandler';
import { usePrimeOrderFormClientTool } from './tools/primeOrderForm';

/** The single client composition root; adding a tool does not change the chat provider. */
export function useAvaAIClientTools() {
  const primeOrderForm = usePrimeOrderFormClientTool();

  return useMemo(() => {
    const clientTools: AvaAIClientToolRegistry = {
      [primeOrderForm.name]: primeOrderForm,
    };

    return createAvaAIClientToolRouter(clientTools);
  }, [primeOrderForm]);
}
